import { toast } from "react-toastify";
import { getTokenFromLocal, handleResponse } from "../../_helpers/handleResponseMiddleware";

let centralBaseCommonUrl = process.env.REACT_APP_CENTRAL_BASE_URL;

export function centralGetLensBrandService() {
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return fetch(
      `${centralBaseCommonUrl}/get-lens-types`,
      requestOptions
    )
      .then(handleResponse)
   .then(res => res)
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
  }

export function centralGetLensModelService(params) {
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return fetch(
      `${centralBaseCommonUrl}/get-lens-types?brand=${params}`,
      requestOptions
    )
      .then(handleResponse)
   .then(res => res)
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
  }

  export function centralAddLensDetailsService(params) {
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body:JSON.stringify({ ...params }),
    };
    return fetch(
      `${centralBaseCommonUrl}/save-lens-details`,
      requestOptions
    )
      .then(handleResponse)
   .then(res => res)
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
  }